<template lang="pug">
  .mr-input(:class="{ 'raise-label': raiseLabel }")
    textarea(
      v-if="inputType == 'textarea'"
      v-bind="combinedAttrs"
      ref="input"
    )

    input(
      v-else
      v-bind="combinedAttrs"
      ref="input"
    )

    label(:for="inputId") {{ label }}

    TransitionExpand
      .input-errors(v-if="inputErrors && inputErrors.length")
        .input-error.xs-f-xsmall.lg-f-xxsmall.max-at-tweak.text-left(role="alert" v-for="error in inputErrors")
          i.icon-warning
          | {{ error }}

</template>


<script>
  import mrInputMixin from './mrInput/mrInputMixin';

  export default {
    name: "MrPhoneInput",

    emits: ['update:modelValue'],
    mixins: [mrInputMixin],

    data() {
      return {
        phoneSize: 0,
        oldSize: 0,
      };
    },

    watch: {
      modelValue(newValue) {
        if (newValue) {
          this.update(newValue);
        }
      }
    },

    mounted() {
      this.update(this.modelValue);
    },

    methods: {
      update(val) {
        if (!val) {
          this.$emit('update:modelValue', val);
          return;
        }

        const el = this.$refs.input;
        const pos = el.selectionEnd;
        const atTheEnd = pos == val.length;

        var hasWhiteSpace = /\s/g.test(val);
        var digits = val.replace(/\D/g, '');
        if (digits.length != this.phoneSize || val.length > this.oldSize || !hasWhiteSpace) {
          this.phoneSize = digits.length;
          val = this.formatPhoneNum(val);
          const dif = val.length - this.oldSize;
          this.oldSize = val.length;
          this.delayTouch(this.v);
          this.$emit('update:modelValue', val);

          if (dif != 0 && !atTheEnd) {
            this.$nextTick(() => {
              el.setSelectionRange(pos, pos);
            });
          }

        }
      },

      formatPhoneNum(input) {
        var digits = input.replace(/\D/g, '');
        var format = '(???) ???-????';
        var international = false;

        var digitLen = Math.min(digits.length, 15);
        if (digits[0] == 1) {
          digitLen--;
        }

        if (digitLen > 10) {
          international = true;
          var countryCodeLen = Math.min(digitLen - 10, 3);
          var extraLen = 15 - digitLen;
          var countryCode = '';
          var i = 0;
          for (i = 0; i < countryCodeLen; i++) {
            countryCode += '?';
          }

          format = countryCode + ' ??? ??? ?? ??';
          for (i = 0; i < extraLen; i++) {
            format += '?';
          }
        }

        if (digits[0] == 1) {
          format = '? ' + format;
        }

        if (international) {
          format = '+' + format;
        }

        digits.split('').forEach(function(digit) {
          format = format.replace('?', digit);
        });

        return format.split('?')[0];
      }

    }
  };
</script>

<style scoped lang="stylus">
  .mr-input
    position relative
    display block
    margin 0.55em 0
    font-size 16px

    label
      position absolute
      top 12px
      left 1.1em
      z-index 1
      cursor text
      pointer-events none
      color #666
      font-size 14px
      line-height 1.3em

    input
    textarea
      border-radius 4px
      transition(border-color 0.6s)

      &.invalid
        border 2px solid color-attention

      &:focus
        border 2px solid brand-color-2

    .customDropdown
      .option.expanded
        z-index 2

    &.raise-label
      label
        top 5px
        font-size 10px
        background-color color-white

      input
      textarea
      .select
        padding-top 15px
        padding-bottom 5px

  .input-error
    color color-attention
</style>

